import React from 'react';
import { kodplaner_ekkodplaner } from '../Queries/_QueryTypes/kodplaner';
import { ApolloError } from '@apollo/client';

export interface IKodplanContext {
  loading: boolean;
  error?: ApolloError;
  activeKodplan?: kodplaner_ekkodplaner;
  availableKodplanList: kodplaner_ekkodplaner[];
  setActiveKodplan: (newActiveKodplan: kodplaner_ekkodplaner) => void;
}

export const KodplanContext = React.createContext<IKodplanContext>({
  loading: false,
  availableKodplanList: [],
  setActiveKodplan: () => {},
});

export const KodplanProvider = KodplanContext.Provider;
export const KodplanConsumer = KodplanContext.Consumer;
